//
export default [
    {
        text: 'código interno',
        value: 'internal_code',
        width: '15%',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'solicitado',
        value: 'quantity',
        align: 'right',
        width: '10%',
    },
    {
        text: 'enviar',
        value: 'quantity_to_dispatch',
        align: 'right',
        input: {
            min: 0,
            nativeType: 'number',
            reverse: true,
            type: 'text-field',
        },
        width: '10%',
    },
]
